import { UteUser } from './uteUser';

export class CredentialSession{
    username: string = "";
    password: string = "";
    remember_credentials: boolean = false;
    language: string = "it";

}